import { useState, useEffect } from "react";

/**
 * Hook personalizado para detectar cambios en el breakpoint de pantalla
 * @param {number} maxWidth - Ancho máximo en píxeles (por defecto 780px)
 * @returns {boolean} true si el ancho de la pantalla es menor o igual al maxWidth
 */
export function useIsMobileBreakpoint(maxWidth = 780) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const onChange = () => setIsMobile(mq.matches);

    onChange(); // inicializar
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, [maxWidth]);

  return isMobile;
}
